import React from "react";
import style from "../styles/notfound.module.scss";
import image from "../assets/images/404.png";
import { Link } from "react-router-dom";
import withHelmet from "../seo/withHelmet";
import { notFoundHelmetProps } from "../seo/helmetProps";

const NotFound = () => {
  return (
    <div className={style.container}>
      <img src={image} alt="404 - Page Not Found" />
      <h1>404 - Faqja nuk u gjet</h1>
      <h3>Na vjen keq, por nuk mund të gjejmë atë që po kërkoni.</h3>
      <p>The page you're looking for doesn't exist or has been moved.</p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          alignItems: "center",
          marginTop: "2rem",
        }}
      >
        <Link to="/">Kthehu në faqen kryesore</Link>
        <Link to="/shop">Shiko produktet</Link>
        <Link to="/about-us">Rreth nesh</Link>
        <Link to="/contact-us">Na kontaktoni</Link>
      </div>
    </div>
  );
};

export default withHelmet(NotFound, notFoundHelmetProps);
